import { Component, OnInit, ElementRef, ViewChildren, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, Inject, ViewRef, HostListener } from '@angular/core';
import { DatePipe } from '@angular/common';
import moment from 'moment';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatTabChangeEvent, MatTabGroup, MatTab, MatTabHeader, MatOptionSelectionChange } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { CdkVirtualScrollViewport } from "@angular/cdk/scrolling";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ReplaySubject, BehaviorSubject } from 'rxjs';
import { CommonConFig } from 'app/core/_base/crud/models/common_config.model';
import { LayoutUtilsService } from 'app/core/_base/crud';
import { FunctionPublic } from '../../nfc/dung-chung/__function/common_function';
import { DungChungService } from '../../nfc/dung-chung/__services/dung-chung.service';

@Component({
	selector: 'm-content-component',
	templateUrl: './content-component.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe]
})

export class ContentComponent implements OnInit {
	@ViewChild(CdkVirtualScrollViewport, { static: false }) cdkVirtualScrollViewPort: CdkVirtualScrollViewport;

	/*----------------------------Config Form ---------------------------*/
	CONFIG: CommonConFig;
	/* ------------------------------------------------------------------*/

	/* --------------------------- Loading.... ---------------------------*/
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */


	/* ------------------- Các form trên dialog --------------------------*/
	HHForm: FormGroup;
	/* ------------------------------------------------------------------ */


	/*------------------------- Extend field: ----------------------------*/
	title: string = '';					// Tiêu đề dialog
	previousIndex: number; 				// Lưu lại vị trí trước đó khi swap các cột trên lưới
	fixedPoint = 2;                		// Số chữ số phần thập phân cho kiểu dữ liệu số.
	isChange: boolean = false;			// Trường kiểm tra dialog có cập nhập - thay đổi dữ liệu hay không
	saveAdded: number[] = []		    // Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	saveAddedCT: number[] = []
	viewLoading: boolean = false;   	// Loading khi mở dialog
	disableNewButton: boolean = true;	// Tắt nút thêm mới hàng khi chưa nhập đủ
	processImport: boolean = false;		// Có đang chạy import
	openTimKiemNangCao = false;
	textQuiDoiDVT = '';
	isUpdateDetail = false;
	currentUpdateDetailPosition = -1;
	/* ------------------------------------------------------------------ */

	@HostListener('window:keyup', ['$event'])
	keyEvent(event: KeyboardEvent) {
		if (event.key == "Escape") { this.back(); }
		this.changeDetectView();
	}

	constructor(
		public dialogRef: MatDialogRef<ContentComponent>,
		// @Inject(MAT_DIALOG_DATA) public data: any,
		private dungChungService: DungChungService,
		private HHFB: FormBuilder,
		public dialog: MatDialog,
		private changeDetect: ChangeDetectorRef,
	) {
		this.dialogRef.disableClose = true;
	}

	/*---------------------------- LOAD DATA --------------------------------*/
	ngOnInit() {
		this.CONFIG = new CommonConFig();
		this.title = this.getTitle();
	}
	/* -----------------------------------------------------------------------*/


	/*----------------- Create Form with appropriate sub forms ---------------*/
	getTitle(): string {
		return 'Quy ước Mã hàng nhập A.B.C.DE.F';
	}
	downloadFile() {
		let linkdownload = this.dungChungService.downloadFileQuyCachDatMa();
		window.open(linkdownload);
	}
	/* -----------------------------------------------------------------------*/

	/*----------------- Hàm hỗ trợ format các dạng ngày trên form ------------*/
	getFormatDate(v: string = '') {
		if (v != null && v != undefined && v != '') {
			return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
		return '';
	}
	f_convertDate(p_Val: any) {
		if (p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	/* -----------------------------------------------------------------------*/


	/*------------------------------ Extend Options --------------------------*/
	back() {
		this.dialogRef.close();
	}
	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
	scrollToBottom() {
		setTimeout(() => {
			let height = document.getElementById('dialog-form').scrollHeight
			document.getElementById('dialog-form').scrollTo({ top: height, behavior: 'smooth' });
		}, 200);
	}
	highlightNewestRecord(currentPosition: number) {
		if (this.saveAddedCT.findIndex(x => x == currentPosition) > -1) {
			return true;
		}
		return false;
	}
	/* -----------------------------------------------------------------------*/
}